import {
  getSelectDropdownListFloatingConfig,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_ENTITY,
} from '../../Select'

export const POST_MESSAGE_TEMPLATE_SELECT_PAGE_SIZE = 10

export const POST_MESSAGE_TEMPLATE_SELECT_API_PARAMS = {
  hidden: false,
  ordering: 'name',
  page_size: POST_MESSAGE_TEMPLATE_SELECT_PAGE_SIZE,
}

export const POST_MESSAGE_TEMPLATE_SELECT_DROPDOWN_FLOATING_CONFIG =
  getSelectDropdownListFloatingConfig(SELECT_DROPDOWN_LIST_MAX_HEIGHT_ENTITY)
